import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useSplitModal } from '../context/SplitModalContext';

const SplitModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useSplitModal();

  const isValidNominalValue =
    data.newNominalValue !== data.nominalValue && data.isValidNominalValue;

  const buttonEnabledScriptureView = data.scriptureView && data.date;
  const buttonEnabledMovementsView = !data.scriptureView && isValidNominalValue;
  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveSplit}
          disabled={!buttonEnabledScriptureView && !buttonEnabledMovementsView}
        >
          {buttonText}
        </button>
      </Modal.Footer>
    </>
  );
};

export default SplitModalFooter;
